<template>
    <div class="p-4 mb-5 bg-gray-100 rounded shadow">

        <div v-if="! criteria.length" class="text-gray-700">
            {{ __('admin::labels.no_criteria_added') }}
        </div>

        <div v-else>
            <div class="ml-6 mb-2 grid grid-cols-11 gap-4 mb-2">
                <strong class="col-span-5">{{ __('admin::labels.criterium') }}</strong>
                <strong class="col-span-5">{{ __('admin::labels.value') }}</strong>
            </div>

            <div v-for="(set, setIndex) in criteria" class="mb-6 pl-4 border-l-2 border-gray-700 space-y-2">

                <div v-for="(line, lineIndex) in set" class="grid grid-cols-11 gap-4">

                    <Select
                        name="criteria[setIndex][lineIndex]['criterium']"
                        :options="selectableCriteriumOptions"
                        v-model="criteria[setIndex][lineIndex]['criterium']"
                        :required="true"
                        :placeholder="__('admin::labels.criteria')"
                        class="col-span-5"
                    />

                    <Component
                        v-if="criteria[setIndex][lineIndex]['criterium']"
                        :is="criteriumOptions[criteria[setIndex][lineIndex]['criterium']].component"
                        v-bind="criteriumOptions[criteria[setIndex][lineIndex]['criterium']].properties"
                        v-model="criteria[setIndex][lineIndex]['value']"
                        :required="true"
                        :placeholder="criteriumOptions[criteria[setIndex][lineIndex]['criterium']].component === 'Select' ? __('admin::labels.select') : __('admin::labels.value')"
                        class="col-span-5"
                    />

                    <button type="button" class="flex items-center justify-center bg-gray-500" @click="removeLine(setIndex, lineIndex)">
                        <XIcon class="w-5 h-5 text-white" />
                    </button>
                </div>

                <button type="button" class="flex items-center mt-2 text-indigo-500 focus:outline-none" @click="addLine(set)">
                    <PlusIcon class="inline-block w-4 h-4 mr-1" />
                    {{ __('admin::mapping.add_line') }}
                </button>

            </div>
        </div>

        <button type="button" class="flex items-center mt-4 text-indigo-500 focus:outline-none" @click="addSet">
            <PlusIcon class="inline-block w-4 h-4 mr-1" />
            {{ __('admin::mapping.add_set') }}
        </button>

    </div>
</template>

<script>
import { PlusIcon, XIcon } from '@heroicons/vue/outline';

export default {
    components: {
        PlusIcon,
        XIcon,
    },
    props: {
        criteriumOptions: Object,
        modelValue: Array,
    },
    data() {
        return {
            criteria: this.modelValue,
        };
    },
    computed: {
        selectableCriteriumOptions() {
            const options = {};
            for (let property in this.criteriumOptions) {
                options[property] = this.criteriumOptions[property].name;
            }
            return options;
        },
    },
    watch: {
        criteria: {
            handler(newVal) {
                this.$emit('update:modelValue', newVal);
            },
            deep: true,
        },
    },
    methods: {
        addSet() {
            this.criteria.push([
                {
                    criterium: Object.keys(this.criteriumOptions)[0],
                    value: '',
                },
            ]);
        },
        removeLine(setIndex, index) {
            this.criteria[setIndex].splice(index, 1);

            if (this.criteria[setIndex].length === 0) {
                this.criteria.splice(setIndex, 1);
            }
        },
        addLine(set) {
            set.push({
                criterium: Object.keys(this.criteriumOptions)[0],
                value: '',
            });
        },
    },
}
</script>
